import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {
  fetchPayrolls: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchPayrolls';

    commit(`${mutationPrefix}Pending`);

    return api.fetchPayrolls(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  exportPayroll: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchPayrolls';

    commit(`${mutationPrefix}Pending`);

    return api.exportPayroll(args)
      .then((response) => {
        dispatch('insert', { data: response });

        commit(`${mutationPrefix}Success`, response);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/payroll/actions.js